import { c as _c } from "react/compiler-runtime";
import { PrimaryButton } from '@systemeio/ui';
import MobileSettingsHeader from 'modules/funnels/funnel/components/mobile-settings-header';
import { useDeviceMode } from 'modules/funnels/funnel/context/device-mode-context';
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import ChangeIconNew from 'modules/funnels/funnel/icons/change-icon-new';
import React, { useState, type JSX } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useWindowSize from 'shared/hooks/use-window-size';
import EditIcon from '../../icons/edit-icon';
import { EyeIcon } from '@systemeio/ui/icons';
interface StepConfigurationTabLayoutProps {
  children: JSX.Element;
  viewLinkUrl: string;
  editLinkUrl: string;
  onChangeTemplate: () => Promise<void>;
  additionalAction?: JSX.Element;
  customEditButton?: JSX.Element;
}
function StepConfigurationTabLayout(t0) {
  const $ = _c(42);
  const {
    children,
    viewLinkUrl,
    editLinkUrl,
    onChangeTemplate,
    additionalAction,
    customEditButton
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [changeTemplateConfirmationOpen, setChangeTemplateConfirmationOpen] = useState(false);
  const {
    isMobile
  } = useDeviceMode();
  const {
    width
  } = useWindowSize();
  const isDesktopMode = width > 1170;
  const t1 = `flex ${isDesktopMode ? "flex-row" : "flex-col-reverse"} gap-7 px-[15px] pb-5 lg:gap-5 lg:px-[15px] lg:pb-7 xl:gap-10 ${isMobile ? "bg-background-secondary rounded-lg" : ""}`;
  let t2;
  if ($[0] !== children) {
    t2 = <div className="w-full lg:w-4/5">{children}</div>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <EyeIcon className="fill-background-secondary h-[20px] w-[20px]" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t("dashboard.funnel.configuration.common.view_funnel_step");
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <span className="text-start">{t4}</span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5 || $[8] !== viewLinkUrl) {
    t6 = <PrimaryButton as={LinkWithoutPrefetch} className="!justify-start" href={viewLinkUrl} target="_blank" data-test-element="view-funnel-step-button">{t3}{t5}</PrimaryButton>;
    $[7] = t5;
    $[8] = viewLinkUrl;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== customEditButton || $[11] !== editLinkUrl || $[12] !== t) {
    t7 = customEditButton ? customEditButton : <PrimaryButton as={LinkWithoutPrefetch} className="!justify-start" href={editLinkUrl} target="_self" data-test-element="edit-page-funnel-step-button"><EditIcon className="fill-background-secondary h-[18px] w-[18px]" /><span className="text-start">{t("dashboard.funnel.configuration.common.edit_page")}</span></PrimaryButton>;
    $[10] = customEditButton;
    $[11] = editLinkUrl;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setChangeTemplateConfirmationOpen(true);
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChangeIconNew className="fill-background-secondary h-[18px] w-[18px]" />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("dashboard.funnel.configuration.common.change_page_template");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <PrimaryButton className="!justify-start" onClick={t8} data-test-element="change-page-template-funnel-step-button">{t9}<span className="text-start">{t10}</span></PrimaryButton>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== additionalAction || $[21] !== t11 || $[22] !== t6 || $[23] !== t7) {
    t12 = <div className="flex flex-col gap-4 xl:ml-auto">{t6}{t7}{t11}{additionalAction}</div>;
    $[20] = additionalAction;
    $[21] = t11;
    $[22] = t6;
    $[23] = t7;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <MobileSettingsHeader type={FunnelStepSettingTabsEnum.stepConfiguration} />;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t1 || $[27] !== t12 || $[28] !== t2) {
    t14 = <div className={t1}>{t2}{t12}{t13}</div>;
    $[26] = t1;
    $[27] = t12;
    $[28] = t2;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("dashboard.funnel.configuration.common.change_page_template_confirm");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => setChangeTemplateConfirmationOpen(false);
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== onChangeTemplate) {
    t17 = () => onChangeTemplate();
    $[33] = onChangeTemplate;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== changeTemplateConfirmationOpen || $[36] !== t15 || $[37] !== t17) {
    t18 = <ConfirmationModal confirmationText={t15} opened={changeTemplateConfirmationOpen} onClose={t16} onConfirm={t17} />;
    $[35] = changeTemplateConfirmationOpen;
    $[36] = t15;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t14 || $[40] !== t18) {
    t19 = <>{t14}{t18}</>;
    $[39] = t14;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  return t19;
}
export default StepConfigurationTabLayout;